function updateCanonicalTag(route) {
    if (typeof window === "undefined") return;
    const hostname = window.location.origin;
    const pathname = route.path;

    if (hostname && pathname) {
        $('link[rel="canonical"]').attr('href',
            hostname + (pathname.length > 1 ? pathname : '')
        );
    }
}

export default updateCanonicalTag;
